module.exports = "/_next/static/images/bfb80509b7c40423d5d260c0debbb44b-man-holding-two-phones@0.5x.jpg";